<div class="sliderzoom__container">
  <div class="slider-elements">
    <mat-icon class="icon-close" mat-dialog-close>close</mat-icon>
    @if ((data.slideCount ?? 0) > 1) {
    <div class="slider-elements-control slider-elements-control-previous">
      <mat-icon
        class="chevron-left"
        (click)="(data.slideActive ?? 0) <= 1 ? sliderSlide(data.slides?.length ?? 0 - 1) : sliderPrevious()"
        >chevron_left</mat-icon
      >
    </div>
    }
    <swiper
      [config]="data.swiperOptions"
      (swiper)="sliderInit()"
      (slideChange)="sliderChange($event)"
      effect="fade"
      class="slider-swiper"
      #swiperSlider>
      @for (slide of data.slides; track identifyByIndex($index)) {
      <ng-template swiperSlide>
        <div class="swiper-slide-item-wrapper">
          <div class="swiper-slide-item">
            <ng-container *ngTemplateOutlet="slide"></ng-container>
          </div>
        </div>
      </ng-template>
      }
    </swiper>
    @if ((data.slideCount ?? 0) > 1) {
    <div class="slider-elements-control slider-elements-control-next">
      <mat-icon
        class="chevron-right"
        (click)="(data.slideActive ?? 0) >= (data.slideCount ?? 0) ? sliderSlide(0) : sliderNext()"
        >chevron_left</mat-icon
      >
    </div>
    }
  </div>
  <div class="slider-descriptions">
    @for (title of data.titles; track identifyByIndex(i); let i = $index) { @if (i + 1 === data.slideActive) {
    <ng-container *ngTemplateOutlet="title"></ng-container>
    } }
  </div>
  <div class="slider-meta slider-meta-zoomed">
    <div class="slider-meta-counter">
      <div class="slider-meta-counter-text">{{ data.slideActive }} / {{ data.slideCount }}</div>
    </div>
    <div class="slider-meta-previews" id="sliderMetaPreviews">
      @if (data.slides) { @for (slide of data.slides; track identifyByIndex(i); let i = $index) {
      <div class="slider-previews-wrapper" [id]="'sliderMetaPreviews' + (i + 1)">
        <div
          class="slider-previews-item"
          [class]="{ 'slider-item-active': i + 1 === data.slideActive }"
          (click)="sliderSlide(i)">
          <ng-container *ngTemplateOutlet="slide"></ng-container>
        </div>
      </div>
      } }
    </div>
    <div class="slider-meta-dots">
      @if (data.slides) { @for (slide of data.slides; track identifyByIndex(i); let i = $index) {
      <div
        class="slider-dots-item"
        [class]="{ 'slider-item-active': i + 1 === data.slideActive }"
        (click)="sliderSlide(i)"></div>
      } }
    </div>
  </div>
</div>
